<template>
  <div class="relative">
    <label v-if="title" class="block text-sm mb-1">
      {{ title }}
      <span v-if="required" class="text-red-500">*</span>
    </label>
    <button
      @click="isOpen = !isOpen"
      type="button"
      :class="isOpen ? 'outline-primary-blue' : 'outline-transparent'"
      class="outline-2 bg-gray-100/75 rounded-lg text-[15px] w-full flex items-center justify-between px-3.5 h-12 cursor-pointer"
    >
      <span>{{ selected || title }}</span>
      <BaseLoader size="size-5 min-w-5" v-if="loading" />
      <div v-else class="flex items-center justify-center text-gray-600">
        <Icon name="tabler:chevron-up" v-if="isOpen" size="20" />
        <Icon name="tabler:chevron-down" size="20" v-else />
      </div>
    </button>
    <div
      v-if="isOpen"
      class="fixed inset-0 z-99 flex items-center justify-center bg-black/25"
    ></div>
    <Transition
      enter-active-class="slideInUp"
      leave-active-class="slideOutDown"
    >
      <div
        v-if="isOpen"
        @click="isOpen = false"
        class="fixed inset-0 z-100 flex sm:items-center items-end justify-center bg-transparent"
      >
        <div
          @click.stop
          class="sm:w-96 w-full bg-white border border-gray-200 shadow-2xl sm:rounded-b-lg rounded-t-lg flex flex-col overflow-hidden"
          :class="[height]"
        >
          <div
            class="px-4 py-3 border-b border-gray-100 flex items-center justify-between"
          >
            <span></span>
            <span class="font-semibold">{{ title }}</span>
            <button
              type="button"
              @click.stop="isOpen = false"
              class="size-7 min-w-7 flex items-center justify-center hover:bg-gray-200 cursor-pointer rounded-full transition-colors"
            >
              <Icon name="ph:x" size="16" />
            </button>
          </div>

          <div class="overflow-y-auto hover-scroll p-2">
            <div
              @click="selectItem(item)"
              class="p-2.5 cursor-pointer hover:bg-gray-100 rounded-xl text-[15px]"
              v-for="(item, index) in items"
              :key="item.id || index"
            >
              <slot name="item" :item="item"></slot>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits(["select"]);

withDefaults(
  defineProps<{
    loading?: boolean;
    items?: any[];
    selected?: any;
    title?: string;
    position?: "bottom" | "top";
    height?: string;
    required?: boolean;
  }>(),
  {
    loading: false,
    title: "Select",
    items: () => ["Item 1 ", "Item 2", "Item 3"],
    position: "bottom",
    height: "h-auto",
    required: false,
  },
);

const isOpen = ref<boolean>(false);

const selectItem = (item: any) => {
  emit("select", item);
  isOpen.value = false;
};
</script>
